import { render, staticRenderFns } from "./CheckBoxQuestion.vue?vue&type=template&id=726dea90&scoped=true"
import script from "./CheckBoxQuestion.vue?vue&type=script&lang=ts"
export * from "./CheckBoxQuestion.vue?vue&type=script&lang=ts"
import style0 from "./CheckBoxQuestion.vue?vue&type=style&index=0&id=726dea90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726dea90",
  null
  
)

export default component.exports